import {
  accountPath,
  useActiveAccountContext,
  workspacePath,
} from '@/true-fsd/data/advertiser-account';
import {
  AddChannelToAccount,
  type AddChannelToAccountProps,
} from '@/true-fsd/features/AwaitNewChannel';
import { ButtonLink } from '@/true-fsd/shared/ui/ButtonLink';
import { FigmaWhiteLayout } from '@/true-fsd/shared/ui/FigmaLayout';
import { useCallback } from 'react';

export type AddChannelToAccountPageProps = {
  backLink: string;
};
export const AddChannelToAccountPage = ({
  backLink,
}: AddChannelToAccountPageProps) => {
  const { activeAccount } = useActiveAccountContext();

  const onContinue: NonNullable<AddChannelToAccountProps['onContinue']> =
    useCallback(
      (navigate) => {
        void navigate(accountPath(activeAccount));
      },
      [activeAccount],
    );

  const onChannel: NonNullable<AddChannelToAccountProps['onChannel']> =
    useCallback((navigate, ws) => {
      void navigate(workspacePath(ws));
    }, []);

  const RenderAwaitBack: AddChannelToAccountProps['RenderAwaitBack'] =
    useCallback(
      ({ navigate: __, ...props }) => (
        //to WorkspaceTypeSelect
        <ButtonLink {...props} to={backLink} />
      ),
      [backLink],
    );

  return (
    <AddChannelToAccount
      RenderAwaitLayout={FigmaWhiteLayout}
      RenderAwaitBack={RenderAwaitBack}
      RenderPollLayout={FigmaWhiteLayout}
      onChannel={onChannel}
      onContinue={onContinue}
    />
  );
};
